/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgNotificationOff = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="m15.379 17 6.707 6.707 1.414-1.414-22-22L.086 1.707 5.31 6.932A6.998 6.998 0 0 0 5 9v2.036l-.005.136a9.088 9.088 0 0 1-.328 2.04c-.166.555-.392 1.023-.676 1.338-.258.286-.56.45-.991.45v2h12.379zm-2-2H6.092a6.59 6.59 0 0 0 .49-1.213c.213-.706.315-1.4.366-1.906A11.08 11.08 0 0 0 7 11.024V9c0-.123.004-.245.013-.365L13.38 15zM21 16.97V15c-.43 0-.733-.164-.991-.45-.284-.315-.51-.784-.676-1.337A9.094 9.094 0 0 1 19 11.036V9A7 7 0 0 0 7.592 3.562l1.425 1.425A5 5 0 0 1 17 9v2.076c.002.044.003.105.007.182a10.941 10.941 0 0 0 .267 1.986L21 16.97z"
        fill="currentcolor"
      />
      <path
        d="M15.92 19.393c-1.485 3.475-6.267 3.47-7.83.02l1.82-.826c.867 1.913 3.39 1.849 4.17.02l1.84.786z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgNotificationOff as NotificationOff };
